// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noBack[data-v-5bc4c850]{background-color:hsla(0,0%,100%,.1)!important}button[data-v-5bc4c850]{color:var(--lms-tenant);background-color:var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
